import { useEffect } from 'react';

// Check interval: every 5 minutes
const CHECK_INTERVAL = 5 * 60 * 1000;

export function useVersionCheck() {
    useEffect(() => {
        const currentVersion = process.env.APP_VERSION;
        const getVersionScore = (v: string | undefined) => {
            if (!v) return 0;
            return parseInt(v.replace(/\D/g, '')) || 0;
        };

        const checkVersion = async () => {
            const currentScore = getVersionScore(currentVersion);
            if (currentScore === 0 && currentVersion !== 'initial') return;

            try {
                // Add timestamp to prevent caching of version.json itself
                const response = await fetch('/version.json', {
                    cache: 'no-store'
                });

                if (!response.ok) return;

                const data = await response.json();
                const serverVersion = data.version;
                const serverScore = getVersionScore(serverVersion);
                
                // Cooldown logic: Don't hard reset more than once per hour
                const lastReset = parseInt(localStorage.getItem('last_hard_reset') || '0');
                const isCooldown = Date.now() - lastReset < 60 * 60 * 1000;

                if (serverScore > currentScore && !isCooldown) {
                    console.log(`[VersionCheck] New version available! Server: ${serverVersion}, Local: ${currentVersion}`);
                    console.warn("[VersionCheck] Preparing Critical Hard Reset...");
                    
                    localStorage.setItem('last_hard_reset', Date.now().toString());
                    localStorage.setItem('app_version', serverVersion);

                    const performHardReset = async () => {
                        try {
                            if ('caches' in window) {
                                const names = await caches.keys();
                                await Promise.all(
                                    names
                                        .filter(name => name !== 'whisper-stt-cache' && name !== 'nllb-onnx-models-v1' && name !== 'free-dict-cache' && name !== 'rich-dict-cache-v2' && name !== 'bergamot-models-v1' && name !== 'marian-onnx-models-v1' && name !== 'transformers-cache' && name !== 'piper-voices-cache')
                                        .map(name => caches.delete(name))
                                );
                            }
                            
                            if ('serviceWorker' in navigator) {
                                const regs = await navigator.serviceWorker.getRegistrations();
                                await Promise.all(regs.map(reg => reg.unregister()));
                            }

                            console.log('[VersionCheck] Hard reset complete. Reload required.');
                            // window.location.reload(); // DESATIVADO TEMPORARIAMENTE
                        } catch (e) {
                            console.error("[VersionCheck] Reset failed:", e);
                        }
                    };

                    performHardReset();
                }
            } catch (error) {
                console.error('Failed to check version:', error);
            }
        };

        // Initial check on mount
        checkVersion();

        
        // Polling removido. A verificação agora é apenas on-mount.

        // Check on visibility change (when user comes back to tab)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                checkVersion();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
}
